<script>
import ForgotUserDataPageCcnsw from "@/views/auth/ccnsw/forgot-userdata.vue";
import ForgotUserDataPageStw from "@/views/auth/statewide/forgot-userdata.vue";
import ForgotUserDataPageDefault from "@/views/auth/default/forgot-userdata.vue";
import {mapGetters} from "vuex";

export default {
  components: { ForgotUserDataPageDefault, ForgotUserDataPageCcnsw, ForgotUserDataPageStw},
  data () {
    return {
      host: '',
    }
  },
  methods: {},
  mounted () {
    this.host = window.location.hostname
  },
  computed: {
    ...mapGetters({
      isStatewide: 'isStatewide'
    }),
    isCCNSW () {
      return (this.host == 'ccnsw.dev.partssearch.com.au')
    },
  }
}
</script>

<template>
  <forgot-user-data-page-ccnsw v-if="isCCNSW"></forgot-user-data-page-ccnsw>
  <forgot-user-data-page-stw v-else-if="isStatewide"></forgot-user-data-page-stw>
  <forgot-user-data-page-default v-else></forgot-user-data-page-default>
</template>
